export enum AccessLevel {
  NO_ACCESS = "NO_ACCESS",
  FULL_ACCESS = "FULL_ACCESS"
}
